<image-to-right [bgColor]="'var(--BhavDarkGreen)'" [imgURL]="'https://d17pctieqt8bom.cloudfront.net/static/woods.jpg'"
  [content]="this.notFoundContent">
</image-to-right>


<ng-template #notFoundContent>
  <div class="content__404">
    <h2 class="text-uppercase text-center">OOPS...ESTA PÁGINA NO ESTÁ DISPONIBLE</h2>
  </div>
</ng-template>